import React, { useEffect, useState } from "react";
import { getProductionOrderList } from "../../../../services/production/productionService";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";

function SearchProductionOrder({
  productionOrderID = 0,
  onSelectProductionOrder,
}) {
  const [productionOrders, setProductionOrders] = useState();
  const getProductionOrderData = async (productionOrderID = 0) => {
    const response = await getProductionOrderList(productionOrderID);
    const { data } = response.data;
    setProductionOrders(data.productionOrders);
  };
  useEffect(() => {
    getProductionOrderData(productionOrderID);
  }, [productionOrderID]);
  return (
    <React.Fragment>
      <CustomDataTableSearch
        data={productionOrders}
        onRefreshData={() => {}}
        onSelectedData={(rowData, originalEvent) => {
          onSelectProductionOrder(rowData);
        }}
        columns={[
          {
            header: "ID",
            field: "ID",
            sortable: true,
            filter: true,
          },
          {
            header: "Plant",
            field: "plantName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.plantName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
            filter: true,
          },
          {
            header: "Item",
            field: "itemName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
            filter: true,
          },
          {
            header: "Qty",
            field: "prodQty",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.prodQty} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
            filter: true,
          },
          {
            header: "Uom",
            field: "uomName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.uomName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
            filter: true,
          },
        ]}
      />
    </React.Fragment>
  );
}

export default SearchProductionOrder;
